import { FormationDetailProps } from '@/types/formation';

export const initiationPremierSecoursFormation: FormationDetailProps = {
  id: '1',
  title: 'Formation Initiation aux Premiers Secours',
  description: 'Apprenez les gestes essentiels de premiers secours pour protéger, examiner, alerter et secourir efficacement une victime dans toute situation d\'urgence.',
  duration: '7 heures (1 jour)',
  category: 'Secourisme',
  imageSrc: '/images/formations/premiersecours.webp',
  slug: 'initiation-premiers-secours',
  reference: 'F-IPS',
  price: 'Sur devis – nous contacter',
  targetAudience: "Futur membre de l'équipe secouriste de l'entreprise",
  prerequisites: "Être âgé de 16 ans\nÊtre apte médicalement",
  objectives: [
    "Alerter les secours adaptés",
    "Protéger une victime ou toute personne du suraccident",
    "Porter secours à une victime de manière appropriée",
    "Identifier l'état d'une victime (conscience, ventilation, traumatismes)",
    "Pratiquer les gestes d'urgence adaptés"
  ],
  program: [
    {
      title: 'La protection et la prévention',
      items: [
        'Repérer les dangers dans une situation d\'accident',
        'Supprimer ou isoler le danger, ou soustraire la victime au danger sans s\'exposer soi-même'
      ]
    },
    {
      title: 'L\'alerte et protection des populations',
      items: [
        'Connaître les numéros d\'urgence',
        'Décrire efficacement la situation pour faciliter l\'arrivée des secours'
      ]
    },
    {
      title: 'Les premiers gestes face à une urgence vitale',
      items: [
        'Reconnaître une victime qui ne répond pas mais respire',
        'Mettre une victime en position latérale de sécurité',
        'Reconnaître une victime en arrêt cardiaque et réaliser une réanimation cardio-pulmonaire avec ou sans défibrillateur',
        'Reconnaître une victime qui s\'étouffe et pratiquer les gestes adéquats'
      ]
    },
    {
      title: 'Les premiers gestes face à une urgence relative',
      items: [
        'Reconnaitre, évaluer et prendre en charge une victime présentant un malaise',
        'Reconnaitre, évaluer et prendre en charge une victime présentant une plaie',
        'Reconnaitre, évaluer et prendre en charge une victime présentant une brûlure',
        'Reconnaitre, évaluer et prendre en charge une victime présentant un traumatisme'
      ]
    }
  ],
  pedagogicalMethods: [
    'Exposés interactifs et démonstrations pratiques',
    'Ateliers d\'apprentissage des gestes et d\'utilisation du matériel',
    'Simulations et mises en situation sur cas concrets',
    'Support de formation remis à chaque participant'
  ],
  evaluationMethods: [
    'Évaluation continue durant la formation à travers les mises en situation',
    'Évaluation certificative en fin de formation',
    'QCM pour évaluation des connaissances théoriques'
  ],
  certification: "Remise d'une attestation de conformité après QCM final validé et évaluation des acquis",
  registrationProcess: [
    'Inscription possible jusqu\'à 48h avant le début de la formation (sous réserve de places disponibles)',
    'Validation de l\'inscription après réception du bon de commande ou de la convention signée'
  ],
  accessibilityCriteria: 'Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.',
  formatterInfo: {
    name: 'Sebastien Davrainville - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
